export const MARKET_CONDITION_OPTIONS = [
	{
		value: '1', percent: '75%', title: 'Making Money',
		desc: 'Strong market conditions. Full exposure.',
		note: 'Aggressively on good market',
		icon: '📈',
		bg: '#d4edda', border: '#28a745', text: '#155724', darkText: '#75c97d'
	},
	{
		value: '2', percent: '50%', title: 'Progressing',
		desc: 'Market trending higher. Moderate exposure.',
		note: 'Built on existing profit',
		icon: '📊',
		bg: '#d1ecf1', border: '#17a2b8', text: '#0c5460', darkText: '#5bc0de'
	},
	{
		value: '3', percent: '25%', title: 'Cautious',
		desc: 'Mixed signals. Reduced exposure.',
		note: '5% units on good setups',
		icon: '⚠️',
		bg: '#fff3cd', border: '#ffc107', text: '#856404', darkText: '#ffc107'
	},
	{
		value: '4', percent: '0%', title: 'All Cash',
		desc: 'Capital preservation. No new buying.',
		note: 'Wait and watch',
		icon: '💵',
		bg: '#f8d7da', border: '#dc3545', text: '#721c24', darkText: '#ff6b6b'
	}
];

export const getMarketConditionOption = (value) => {
	const stringVal = String(value);
	return (
		MARKET_CONDITION_OPTIONS.find(o => o.value === stringVal) ||
		MARKET_CONDITION_OPTIONS.find(o => o.value === '2')
	);
};


